import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Our Products', href: '/products' },
    { name: 'Export & Logistics', href: '/export-logistics' },
    { name: 'Quality Assurance', href: '/quality' },
    { name: 'Partner With Us', href: '/partner' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-200">
      {/* Top bar */}
      <div className="bg-[#1B5E20] text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:+2349038145272" className="flex items-center gap-1 hover:text-[#C8A951] transition-colors">
              <Phone size={14} />
              <span className="hidden sm:inline">+234 903 814 5272</span>
            </a>
            <a href="mailto:info@folalabifarms.com" className="flex items-center gap-1 hover:text-[#C8A951] transition-colors">
              <Mail size={14} />
              <span className="hidden sm:inline">info@folalabifarms.com</span>
            </a>
          </div>
          <div className="text-xs hidden md:block">
            Operating: Nigeria 🇳🇬 | United Kingdom 🇬🇧
          </div>
        </div>
      </div>

      {/* Main header */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_african-agro-export/artifacts/mgbf4mm8_folalabi%20farm%20logo.png" 
              alt="Folalabi Farms Logo" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${
                  isActive(item.href)
                    ? 'text-[#1B5E20] bg-[#1B5E20]/5'
                    : 'text-[#333333] hover:text-[#1B5E20] hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-3">
            <Link to="/quote">
              <Button className="bg-[#C8A951] hover:bg-[#B8994A] text-white font-semibold px-6 shadow-md transition-all hover:shadow-lg">
                Request a Quote
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-[#333333] hover:bg-gray-100"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-md text-sm font-medium transition-all ${
                  isActive(item.href)
                    ? 'text-[#1B5E20] bg-[#1B5E20]/5'
                    : 'text-[#333333] hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/quote" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-[#C8A951] hover:bg-[#B8994A] text-white font-semibold mt-2">
                Request a Quote
              </Button>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
